import axios from '../http'

function add(data) {
    return axios.post('/basedata/projectDoc/add', data);
}

function del(data) {
    return axios.post('/basedata/projectDoc/del', data);
}

function update(data) {
    return axios.post('/basedata/projectDoc/update', data);
}

function query(data) {
    return axios.post('/basedata/projectDoc/query', data);
}

function get(id) {
    return axios.get('/basedata/projectDoc/get?id=' + id);
}

function valid(data) {
    return axios.post('/basedata/projectDoc/valid', data);
}
function invalid(data) {
    return axios.post('/basedata/projectDoc/invalid' , data);
}

function select(data) {
    return axios.post('/basedata/projectDoc/select', data);
}

export default {
    add,
    del,
    update,
    query,
    get,
    valid,
    invalid,
    select
}